import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Radio from 'components/Form/Radio/Radio';
import Banner from 'components/Banner';

import { observer } from 'mobx-react';

import { Fieldset, LegendStyled } from './RadioGroup.styled';

export const radioGroupSize = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  DEFAULT: 'default',
  MEDIUM: 'medium',
};

const RadioGroup = observer(function RadioGroup(props) {
  const { size, items, groupLabel, onOptionChecked, selectedItemId } = props;

  const [selectedOptionIndex, setSelectedOptionIndex] = useState(
    props.checkedOptionIndex,
  );

  const optionChanged = (event, index) => {
    setSelectedOptionIndex(index);
    if (onOptionChecked) onOptionChecked(items[index], event);
  };

  return (
    <Fieldset>
      {groupLabel && <LegendStyled size={size}>{groupLabel}</LegendStyled>}
      {Array.isArray(items) &&
        items.map((obj, index) => {
          const { extraMessage } = obj;
          let isCheckedItem = index === selectedOptionIndex;
          if (selectedItemId !== undefined && selectedItemId !== null) {
            isCheckedItem = selectedItemId === obj.id;
          }
          return (
            <Fragment key={`${obj.id}_${index}`}>
              <Radio
                {...obj}
                size={size}
                groupName={props.groupName}
                checked={isCheckedItem}
                onChange={option => optionChanged(option, index)}
              />
              {extraMessage &&
                (!extraMessage?.showOnSelect ||
                  (extraMessage?.showOnSelect && isCheckedItem)) &&
                (extraMessage?.component ? (
                  <extraMessage.component {...extraMessage.props} />
                ) : (
                  <Banner
                    customIcon={extraMessage?.icon}
                    isVisible={isCheckedItem}
                    text={extraMessage?.text}
                  />
                ))}
            </Fragment>
          );
        })}
    </Fieldset>
  );
});

RadioGroup.defaultProps = {
  size: radioGroupSize.DEFAULT,
};

RadioGroup.propTypes = {
  /**
   * This prop will show the legend <code>fieldset</code> tag for describe the group of radios
   */
  groupLabel: PropTypes.string,
  /**
   * Name of the radiogroup
   */
  groupName: PropTypes.string,
  /**
   * This prop allows to change the size of the component based on our <a href="https://storybook.wikifactory.com/?path=/docs/3--page">typography scale system</a>
   */
  size: PropTypes.oneOf(Object.values(radioGroupSize)),
  items: PropTypes.array,
  checkedOptionIndex: PropTypes.number,
  onOptionChecked: PropTypes.func,
  selectedItemId: PropTypes.any,
};

export default RadioGroup;
